module.exports = __webpack_public_path__ + "img/banner2_1_jp.52c1a5d7.png";